module.exports = __webpack_public_path__ + "img/betsize_btn.4678ebd3.png";